var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppealCreate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.668 1.66602C17.5846 1.66602 18.3349 2.41642 18.335 3.33301V13.333C18.335 14.2497 17.5846 15 16.668 15H5.00098L1.66797 18.333L1.67676 3.33301C1.67685 2.41642 2.41835 1.66602 3.33496 1.66602H16.668ZM8.80176 9.87598L6.91406 7.98828L6.70215 7.77539L6.49023 7.98828L5.79004 8.6875L5.57812 8.90039L8.80176 12.124L15.0137 5.91211L15.2266 5.7002L15.0137 5.48828L14.3145 4.78809L14.1016 4.57617L8.80176 9.87598ZM14.8018 5.7002L8.80176 11.7002L8.80078 11.6992L14.7998 5.7002L14.1006 5.00098L14.1016 5L14.8018 5.7002ZM8.80078 10.2988L8.7998 10.2998L6.70117 8.20117L6.70215 8.2002L8.80078 10.2988Z",
    fill: "#14AC63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppealCreate);
export default __webpack_public_path__ + "static/media/AppealCreate.43750b940f0e011aa79f2a3af41580a4.svg";
export { ForwardRef as ReactComponent };